function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.3468 0.71858L17.0791 11.5048C16.7499 11.8206 16.3018 11.998 15.8358 11.9988H0.877333C0.394878 11.9958 0 11.6148 0 11.153C0 10.9321 0.0907046 10.7196 0.251784 10.5616L10.7688 0.523964C11.0972 0.198358 11.5469 0.00973077 12.0199 0H28.0418C28.2811 0.000748521 28.4781 0.190124 28.4781 0.419171C28.4781 0.53145 28.4304 0.639985 28.3468 0.71858Z",
  fill: "#2CE27E"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M50.9479 0.000748533H32.9164C32.448 0.00224557 31.9984 0.179645 31.6653 0.494772L20.163 11.5055C19.8346 11.8221 19.6493 12.2495 19.6469 12.6957V19.1554C19.6383 19.6135 19.2427 19.9862 18.7634 19.9862C18.7579 19.9862 18.7532 19.9862 18.7477 19.9862H12.0231C11.557 19.987 11.109 20.1644 10.7798 20.4803L0.262731 30.5628C0.0946143 30.7208 0 30.9364 0 31.1617C0 31.6213 0.394878 32 0.875769 32C0.877333 32 0.878897 32 0.880461 32H18.9197C19.3858 31.9993 19.8338 31.8219 20.163 31.506L31.6653 20.4952C31.9976 20.1816 32.1837 19.752 32.1814 19.3051V12.8454C32.1814 12.3813 32.5802 11.9995 33.065 11.9995H39.8131C40.2791 11.9988 40.7272 11.8214 41.0564 11.5055L51.5891 1.43791C51.7572 1.27997 51.8526 1.0644 51.8526 0.838343C51.8526 0.378751 51.4569 0 50.9768 0C50.9674 0 50.9572 0.000748533 50.9479 0.000748533Z",
  fill: "white"
});

var SvgTrunkrsLogo = function SvgTrunkrsLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 52,
    height: 32,
    viewBox: "0 0 52 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrunkrsLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trunkrs-logo.bd76908b.svg";
export { ForwardRef as ReactComponent };